import { Card, Empty, Layout } from "antd";
import { notFoundImage } from "@/Assets/Index";

const { Content } = Layout;

export default function NotFound() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content style={{ padding: "24px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card style={{ width: "100%", maxWidth: "600px" }}>
          <Empty
            image={notFoundImage}
            description={
              <div>
                <h2 style={{ margin: "16px 0 8px 0", fontSize: "18px", fontWeight: "600" }}>
                  There is no page at this address
                </h2>
                <p style={{ margin: 0, color: "#666" }}>
                  Check the URL and try again, or use the search bar to find what you need.
                </p>
              </div>
            }
          />
        </Card>
      </Content>
    </Layout>
  );
}
